import { render } from "./Error404.vue?vue&type=template&id=895bc40a"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__